<template>
    <div>
      <Pos_invoice_Receipt_Full/>
    </div>
  </template>
  
  <script>
  import Pos_invoice_Receipt_Full from "@/components/adminArin/pos_system/pos/Pos_invoice_Receipt_Full";
  export default {
    name: "PosInvoiceReceiptFull",
    components: {
      Pos_invoice_Receipt_Full
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  